import { RichText } from '#components/base/RichtText/RichtText';

import styles from './ArticleModuleText.module.scss';
import sectionStyles from './SectionStyles.module.scss';
import type { ArticleModuleTextFragment } from './__generated__/ArticleModuleText.generated';

type Props = {
	textModule: ArticleModuleTextFragment;
};

export function ArticleModuleText({ textModule }: Props) {
	if (!textModule.text) {
		return null;
	}

	return (
		<section className={`${styles.wrapper} ${sectionStyles.section}`}>
			<RichText className="body3" text={textModule.text} />
		</section>
	);
}
